import React, { FC, ReactNode, Ref, useContext } from 'react';

import { ThemeContext } from 'styled-components';
import FlexRow from '../../structure/_FlexRow';
import FormColContext from '../_FormColContext';

export interface FormRowProps {
  children?: ReactNode;
  /** Defines the default col of every [FormCol](/Core/Components/Form/FormCol) inside the row. */
  defaultCol?: number;
  /** Defines the default `minColWidth` of every [FormCol](/Core/Components/Form/FormCol) inside the row. */
  minColWidth?: number;
  /** Controls the width of the padding elements. Padding elements are used to force columns to collapse when there is no space available. */
  paddingSize?: number;
  /** A ref to the column element. */
  rowRef?: Ref<Element>;
  /** Width of the gutter between rows. */
  gutterWidth?: number;
}

const FormRow: FC<FormRowProps> = ({ gutterWidth, ...props }) => {
  const theme = useContext(ThemeContext);
  return (
    <FlexRow
      ColContext={FormColContext}
      margin={`0 -${gutterWidth || theme.Form.formColGutter}px`}
      gutterWidth={gutterWidth}
      {...props}
    />
  );
};

export default FormRow;
